import { render, staticRenderFns } from "./shipping-box-modal.component.vue?vue&type=template&id=e892d05a&"
import script from "./shipping-box-modal.component.vue?vue&type=script&lang=ts&"
export * from "./shipping-box-modal.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports